import React from 'react';
import styles from './logo.module.scss';
import logoUrl from '@src/assets/img/green_logo.svg';
import { NavLink } from 'react-router-dom';
import { isHomeEDApp } from '@src/constants';
import { DEMO_LANDING_PATH } from '@src/hooks/useDemoAccount';

type Props = { isParentApp?: boolean; isDemoAccount?: boolean; };

function Logo({ isParentApp, isDemoAccount }: Props) {
  return (
    <NavLink to={isParentApp ? '/parent/dashboard' : isHomeEDApp ? '/studyplan' : isDemoAccount ? DEMO_LANDING_PATH : '/dashboard'} className={styles.img}>
      <img className={styles.img} src={logoUrl} alt={'Logo'} />
    </NavLink>
  );
}

export default Logo;
